export class UrlService {

    /**
     * Builds a url using the 'href' attribute of the 'base' element (if the base tag exists on the index page).
     * @param relativePath - The relative path that must start with the root as: '~/' 
     * @param resolvePath - Determines whether the path should be fully resolved to an absolute url.  The default is 'false'.
     */
    build(relativePath: string, resolvePath?: boolean): string {
        if (relativePath.substr(0, 2) != "~/") {
            console.error("Relative URL '" + url + "' must start with '~/'.");
            return;
        }

        var relativePath = relativePath.replace('~/', '');
        var urlRoot = resolvePath ? this.getResolvedRoot() : this.getBaseHref();
        var url = urlRoot + relativePath;
        return url;
    }

    /**
     * Returns the actual href value string of the base element. ex: "/"
     */
    getBaseHref() {
        // Assumes that this attribute has been added to the index page
        var base = document.querySelector('base');
        if (base) {
            return base.attributes['href'].value;
        } else {
            console.warn('No base href tag was found on the index page. Defaulting to "/".');
            return '/';
        }
    }

    /**
     * Returns the fully resolved root url of the base element.  ex: "http://localhost/root/"
     */
    getResolvedRoot() {
        // Assumes that this attribute has been added to the index page
        var base = document.querySelector('base');
        if (base) {
            return base.href;
        } else {
            console.warn('No base href tag was found on the index page. Defaulting to "/".');
            return '/';
        }
    }
}